import api from "./Api";

class VariacaoService {
  GetVariacao(payload) {
    return api.get("/v1/variacao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVariacao(payload) {
    return api.post("/v1/variacao/", payload).then((response) => {
      return response.data;
    });
  }

  PutVariacao(payload) {
    return api.put("/v1/variacao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVariacao(payload) {
    return api.delete("/v1/variacao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVariacaoOData(payload) {
    return api.get("/OData/Variacao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VariacaoService();
